<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Digital Media Server Setting</h4>
        <el-form 
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable DLNA:">
                <el-switch v-model="flag" ></el-switch>
            </el-form-item>
            <div v-if="flag">
            <el-form-item label="Share Folders:">
                <el-radio v-model="radio" label="1">Share All Folders</el-radio>
            </el-form-item>
             <el-form-item >
                <el-radio v-model="radio" label="2">Custom Shared Folder</el-radio>
            </el-form-item>
            <el-form-item v-if="radio==2">
                <el-input placeholder="Shared Folder" v-model="shared" ></el-input>
            </el-form-item>
            </div>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "1",
      loading: false,
      flag: false,
      shared: ""
    };
  },
  methods: {
    ajaxrequesthttp() {
      let postdata = {
        CmdType: "GET_DLNA"
      };
      this.loading = true;
      axios.post("/boafrm/formDLNA", postdata).then(res => {
        this.loading = false;
        let data = res.data;
        if (data == "undefined" || data == "" || data.ret == "-1") {
          this.$message.error("Data acquisition error!");
          return;
        }

        if (data.DLNASwitch == "1") {
          this.flag = true;
        } else {
          this.flag = false;
        }

        if (data.sharedFolderLists.length > 0) {
          if (data.isSharedFolderAll) {
            this.radio = "1";
          } else {
            this.radio = "2";
            this.shared = data.sharedFolderLists[0].name;
          }
        } else {
          this.radio = "1";
        }
      });
    },
    save() {
      if (this.flag == true) {
        var DLNASwitch = 1;
      } else {
        var DLNASwitch = 0;
      }
      var postdata = {
        CmdType: "SET_DLNA",
        DLNASwitch: DLNASwitch,
        folderType: "ADD",
        sharedFolder: this.shared
      };
      if (this.radio == 1) {
        postdata.folderType = "ALL";
      }
      this.loading = true;
      axios.post("/boafrm/formDLNA", postdata).then(res => {
        this.loading = false;
        let data = res.data;
        if (data.ret == "0") {
          this.$message.success("Change setting successfully!");
        } else {
          this.$message.error("Change setting failed!");
          this.aajaxrequesthttp();
        }
      });
    }
  },
  created() {
    this.ajaxrequesthttp();
  }
};
</script>
<style lang="scss" scoped>
.fhv-centent {
  h4 {
    margin-bottom: 15px;
  }
  .change {
    label {
      align-self: flex-start;
    }
  }
  .rad {
    .el-radio{
      opacity: 1;
    }
    div {
      margin-bottom: 10px;
    }
  }
  .btn-contain {
    width: 500px;
  }
   @media (max-width: 768px) {
    .btn-contain{
            width: 100%;
           padding-left: 0;
     }
  }
}
</style>




